/**
 * @generated SignedSource<<da393f2958e710f7b1e7e0653106434a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type WidgetNoteFontSize = "LARGE" | "MEDIUM" | "SMALL";
export type WidgetNoteFontStyle = "BOLD" | "CURSIVE" | "DEFAULT";
export type WidgetNoteStyleInput = {
  backgroundColor?: string | null;
  fontColor?: string | null;
  fontSize?: WidgetNoteFontSize | null;
  fontStyle?: WidgetNoteFontStyle | null;
};
export type useToggleFontColorSetTextColorMutation$variables = {
  noteId: string;
  pageId: string;
  value: WidgetNoteStyleInput;
};
export type useToggleFontColorSetTextColorMutation$data = {
  readonly note: {
    readonly page: {
      readonly setStyle: {
        readonly fontColor: string | null;
        readonly id: string;
      };
    };
  };
};
export type useToggleFontColorSetTextColorMutation$rawResponse = {
  readonly note: {
    readonly page: {
      readonly setStyle: {
        readonly fontColor: string | null;
        readonly id: string;
      };
    };
  };
};
export type useToggleFontColorSetTextColorMutation = {
  rawResponse: useToggleFontColorSetTextColorMutation$rawResponse;
  response: useToggleFontColorSetTextColorMutation$data;
  variables: useToggleFontColorSetTextColorMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "noteId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pageId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "value"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "noteId"
      }
    ],
    "concreteType": "NoteMutation",
    "kind": "LinkedField",
    "name": "note",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "pageId"
          }
        ],
        "concreteType": "NotePageMutation",
        "kind": "LinkedField",
        "name": "page",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "style",
                "variableName": "value"
              }
            ],
            "concreteType": "WidgetNotePage",
            "kind": "LinkedField",
            "name": "setStyle",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fontColor",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useToggleFontColorSetTextColorMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useToggleFontColorSetTextColorMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6390346105aa9a932a77aadf02dbfeaf",
    "id": null,
    "metadata": {},
    "name": "useToggleFontColorSetTextColorMutation",
    "operationKind": "mutation",
    "text": "mutation useToggleFontColorSetTextColorMutation(\n  $noteId: ID!\n  $pageId: ID!\n  $value: WidgetNoteStyleInput!\n) {\n  note(id: $noteId) {\n    page(id: $pageId) {\n      setStyle(style: $value) {\n        id\n        fontColor\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f376ce1be5cdbbe7c17fc7d3cf5494da";

export default node;
